<template>
  <v-dialog
    v-model="active"
    persistent
    width="560"
  >
    <v-card class="primary">
      <v-card-title class="font-weight-bold justify-center">
        Confiabilidad
      </v-card-title>
      <v-card-text align="center">
        <v-img
          src="@/assets/img/logo-puebla.png"
          width="360"
          contain
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="secondary"
          block
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
